// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LineItemsList_wrapper__5ZUjy","divider":"LineItemsList_divider__9s2M9","narrow":"LineItemsList_narrow___LPTi"};